import { useState, useEffect } from "react";
import Traec from "traec";

import { useSelector } from "react-redux";

export const listToMap = (data, key) => {
  return data?.reduce((acc, cur) => acc.set(cur.get(key), cur), Traec.Im.Map());
};

export default function useApi(url) {
  useEffect(() => {
    new Traec.Fetch("generic", "read", { url }).dispatch();
  }, [url]);

  const details = useSelector((state) => state.getInPath(`fetch.GET ${url}`));
  const data = useSelector((state) => state.getInPath(`entities.url.responses.${url}.payload`));

  let status = details?.get("status");
  let isError = status === "failed";
  return {
    data,
    isLoading: !status || status === "sent" || (!isError && !data),
    isError,
    errors: details?.get("errors"),
    error: details?.get("error"),
    failures: details?.get("failures"),
  };
}

export function useLocalStorage(key, initialValue) {
  // Get from localStorage then fallback to initialValue
  const readValue = () => {
    if (typeof window === "undefined") return initialValue;
    try {
      const item = window.localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : typeof initialValue === "function" ? initialValue() : initialValue;
    } catch (error) {
      return typeof initialValue === "function" ? initialValue() : initialValue;
    }
  };

  const [storedValue, setStoredValue] = useState(readValue);

  // Listen for expandAll events and re-read localStorage
  useEffect(() => {
    const handleExpandAll = () => {
      const newValue = readValue();
      if (newValue !== storedValue) {
        setStoredValue(newValue);
      }
    };

    window.addEventListener("expandAll", handleExpandAll);
    return () => window.removeEventListener("expandAll", handleExpandAll);
  }, [key, storedValue]);

  // Update localStorage when value changes
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue));
    } catch (error) {
      // Ignore write errors
    }
  }, [key, storedValue]);

  // Return API identical to useState
  const setValue = (value) => {
    setStoredValue((prev) => {
      const valueToStore = value instanceof Function ? value(prev) : value;
      return valueToStore;
    });
  };

  return [storedValue, setValue];
}
